import React from "react";

const Contact = () => (
  <section
    id="contact-section"
    className="min-h-screen bg-[#f9f9f9] dark:bg-slate-900 py-16 px-4 sm:px-6 font-[Inter] transition-colors"
  >
    <div className="max-w-3xl mx-auto bg-white dark:bg-slate-800 p-6 sm:p-10 rounded-2xl shadow-xl transition-all duration-300">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-[DM Sans] font-bold text-center text-[#111011] dark:text-white mb-4">
        Contact Us
      </h2>
      <p className="text-center text-base text-gray-600 dark:text-gray-300 mb-8">
        We're here to help—share your needs, ideas, or questions and our team will get back to you promptly.
      </p>

      {/* Embedded Microsoft Form */}
      <div className="w-full flex justify-center">
        <iframe
          width="640"
          height="600"
          src="https://forms.office.com/Pages/ResponsePage.aspx?id=r7yyH0cUIEOXCwqByrnzpcvYzhIIMLVBsVinNL9FO_ZUREM4TjdMM1pRVEdKSE9FQTdWT1FLTU5HMSQlQCN0PWcu&embed=true"
          frameBorder="0"
          marginWidth="0"
          marginHeight="0"
          title="Contact Blackbear Technologies"
          style={{
            border: "none",
            maxWidth: "100%",
            minWidth: "320px",
            minHeight: "480px",
            maxHeight: "100vh",
            background: "transparent",
          }}
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          msallowfullscreen="true"
        ></iframe>
      </div>

      <div className="text-center mt-10 text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
        Visit{" "}
        <a
          href="https://www.BlackBearTechnologies.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 dark:text-blue-400 hover:underline"
        >
          www.BlackBearTechnologies.ca
        </a>{" "}
        or contact us at{" "}
        <a
          href="mailto:support@blackbeartechnologies.ca"
          className="hover:underline text-blue-600 dark:text-blue-400"
        >
          support@blackbeartechnologies.ca
        </a>
        <br />
        Tel:{" "}
        <a href="tel:18776178450" className="hover:underline">
          1-877-617-8450
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
